<template>
  <div>
    <div class="banner">
      <div class="banner-content">
        <img
          class="img-fluid"
          src="../assets/images/banner/register_banner.jpg"
          alt="banner"
        />
        <div class="banner-text">
          <h1>申請入會</h1>
          <div class="banner-text-line"></div>
          <span>Membership Application</span>
        </div>
      </div>
    </div>
    <div
      class="contentContainer-noMove"
      :style="{ backgroundImage: 'url(' + BG + ')' }"
    >
      <div class="content">
        <!-- 註冊流程圖 -->
        <template v-if="nowStep === 1">
          <div class="content-title">
            <h2>入會說明</h2>
            <div class="bread">
              <router-link to="/">
                <i class="fas fa-home fa-lg"></i>
              </router-link>
              <span>></span>
              申請入會
            </div>
          </div>
          <div class="content-textBox">
            <div class="first-section">
              <div class="text">
                <h3>本會會員申請資格如下：</h3>
                <ul class="list-unstyled">
                  <li>
                    <p>個人會員:</p>
                    <p>
                      凡贊同本會宗旨、年滿20歲、具有認同本會宗旨，並具有推動口腔衛生及健康促進經驗的相關系所人士，填具入會申請書，經理事會審查通過，並繳納會費後，為個人會員；入會費新臺幣壹仟元，於會員入會時繳納；常年會費壹仟元。
                    </p>
                  </li>
                  <li>
                    <p>學生會員:</p>
                    <p>
                      以學生身分加入，為本會學生會員。入會費為伍佰元，就學期間常年會費為伍佰元。
                    </p>
                  </li>
                </ul>
                <!-- <p>
                  一、個人會員:凡贊同本會宗旨、年滿二十歲者，並符合以下兩類資格之一者。
                </p>
                <ul class="list-unstyled">
                  <li>
                    <p>第一類:視網膜臨床專科醫師，請同時具備下列資格:</p>
                    <p>
                      1.凡在政府認可之國內外醫學院校畢業，並取得行政院衛生署核發之眼科專科醫師證書資格者。
                    </p>
                    <p>
                      2.受過一年以上視網膜專科訓練，或經本會遴選委員會推薦者。
                    </p>
                  </li>
                  <li>
                    <p>
                      第二類:醫學相關學術領域研究有成者，且具備下列資格之一:
                    </p>
                    <p>1.從事視網膜醫學會領域之研究或教學者。</p>
                    <p>2.曾就讀於國內外大學，其學術論文與視網膜研究相關者。</p>
                  </li>
                </ul> -->
                <!-- <p>
                  ※上述兩類之申請者，申請時應填具入會申請書，由本會會員二人以上之介紹，經理事會審查通過，並繳納會費方可取得會員資格（其中第二類會員尚須提出已出版之學術論文）。
                </p> -->
                <!-- <p>
                  ※入會費:會員新台幣伍仟元，準會員新台幣壹仟元，於入會時繳納。
                </p>
                <p>※常年會費:會員新台幣壹仟元。</p> -->
              </div>
              <h3>本會會員申請入會辦法及流程說明：</h3>
            </div>
            <div class="process">
              <div class="process-title">會員申請入會辦法及流程</div>
              <div class="process-box">
                <template v-for="(step, index) in Steps">
                  <div :key="index">
                    <div class="step_box">
                      <div class="subtitle">
                        <div>Step.0{{ index + 1 }} {{ step.Title }}</div>
                        <div v-if="step.Title2">{{ step.Title2 }}</div>
                      </div>
                      <div class="info">
                        <div>{{ step.Info }}</div>
                        <div
                          v-if="step.Remark"
                          v-html="step.Remark"
                          class="remark"
                        ></div>
                      </div>
                    </div>
                    <div class="nextStep" v-if="index < 6">
                      <i class="fas fa-angle-double-down fa-3x"></i>
                    </div>
                  </div>
                </template>
              </div>
              <div class="btn-box">
                <div class="btn blue-btn" @click.prevent="goNext(2)">
                  <a href="#">加入會員</a>
                </div>
                <div class="contact-back btn">
                  <router-link to="/">
                    回首頁
                    <img
                      src="../assets/images/icon/back_icon.png"
                      alt="回首頁"
                    />
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </template>
        <!-- 輸入帳號密碼 -->
        <template v-if="nowStep === 2">
          <div class="content-title">
            <h2>帳號註冊</h2>
            <div class="bread">
              <router-link to="/">
                <i class="fas fa-home fa-lg"></i>
              </router-link>
              <span>></span>
              加入會員
              <span>></span>
              帳號註冊
            </div>
          </div>
          <div class="content-textBox">
            <div class="first-section">
              <div class="content-contact">
                <div class="content-contact-border">
                  <div class="input_span">
                    <span>帳號(Email)</span>
                    <input
                      type="text"
                      placeholder="請填寫完整E-mail"
                      v-model.trim="RegisterData.Email"
                      name="Email"
                    />
                  </div>
                  <div class="input_span">
                    <span>密碼</span>
                    <input
                      type="password"
                      placeholder="請輸入6~12碼數字英文混合"
                      v-model.trim="RegisterData.Password"
                      name="Password"
                    />
                  </div>
                  <div class="input_span">
                    <span>再次確認密碼</span>
                    <input
                      type="password"
                      placeholder="再次輸入同上填寫的密碼"
                      v-model.trim="RegisterData.CheckPwd"
                      name="CheckPwd"
                    />
                  </div>
                  <div class="input_span fs">
                    <span>請輸入驗證碼</span>
                    <div class="id">
                      <input
                        type="text"
                        placeholder="請輸入驗證碼"
                        v-model="InputId"
                      />
                      <Sidentify :identifyCode="identifyCode"></Sidentify>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        width="35"
                        height="35"
                        viewBox="0 0 172 172"
                        style="fill: #000000"
                        @click="refreshCode"
                      >
                        <g
                          fill="none"
                          fill-rule="none"
                          stroke="none"
                          stroke-width="1"
                          stroke-linecap="butt"
                          stroke-linejoin="miter"
                          stroke-miterlimit="10"
                          stroke-dasharray
                          stroke-dashoffset="0"
                          font-family="none"
                          font-weight="none"
                          font-size="none"
                          text-anchor="none"
                          style="mix-blend-mode: normal"
                        >
                          <path
                            d="M0,172v-172h172v172z"
                            fill="none"
                            fill-rule="nonzero"
                          />
                          <g fill="#333333" fill-rule="evenodd">
                            <g id="surface1">
                              <path
                                d="M109.82357,31.85808c-13.10156,-5.76693 -27.88281,-6.66276 -41.62826,-2.32357c-26.11914,8.23047 -43.05599,33.00586 -41.29232,60.27278l-17.83268,1.17578c-2.29557,-35.5254 19.79232,-67.7754 53.75,-78.4974c19.87631,-6.27083 41.43229,-4.08724 59.71289,5.79492l17.10482,-18.2806l4.56315,50.69857l-53.69401,1.79167zM109.15169,159.51433c-7.5306,2.35156 -15.34115,3.55533 -23.0957,3.55533c-12.65365,0 -25.22331,-3.27539 -36.5612,-9.37825l-17.13281,18.30859l-4.53515,-50.69857l53.66601,-1.79167l-19.28841,20.63217c13.04557,5.73893 27.82682,6.66276 41.57226,2.32356c26.11914,-8.25846 43.08399,-33.06185 41.32031,-60.27278l17.80469,-1.17578c2.35156,35.4694 -19.76433,67.7474 -53.75,78.4974z"
                              />
                            </g>
                          </g>
                        </g>
                      </svg>
                    </div>
                  </div>
                  <div class="contact-btnBlock">
                    <div class="item">
                      <div class="btn blue-btn islogin" @click="Register">
                        <a href="javascript:;">完成送出</a>
                      </div>
                    </div>
                    <div class="item">
                      <div class="btn white-btn islogin" @click="Reset">
                        <a href="javascript:;">重新填寫</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="contact-back">
                <router-link to="/">
                  回首頁
                  <img src="../assets/images/icon/back_icon.png" alt="回首頁" />
                </router-link>
              </div>
            </div>
          </div>
        </template>
        <template v-if="nowStep === 3">
          <div class="content-title">
            <h2>帳號註冊-驗證中</h2>
            <div class="bread">
              <router-link to="/">
                <i class="fas fa-home fa-lg"></i>
              </router-link>
              <span>></span>
              加入會員
              <span>></span>
              帳號註冊
            </div>
          </div>
          <div class="content-contact">
            <div class="content-contact-border">
              <div class="member-box register">
                <h3>
                  E-mail 帳號：<span>{{ RegisterData.Email }}</span>
                </h3>
                <p>
                  若您為收到驗證信，同時垃圾信箱也未收到，<br />請點擊"寄送驗證信後"，再次進入您的信箱確認信件
                </p>
                <p>
                  如果經一段，您仍然沒有收到<span>台灣口腔衛生科學學會</span>的帳號驗證郵件，<br />郵件有可能被分類到垃圾信件，請查看您的垃圾郵件信箱。
                </p>
                <div class="btn blue-btn submission-btn" @click="openPop">
                  <a class href="javascript:;">寄送驗證信</a>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-if="nowStep === 4">
          <div class="content-title">
            <h2>認證</h2>
            <div class="bread">
              <router-link to="/">
                <i class="fas fa-home fa-lg"></i>
              </router-link>
              <span>></span>
              加入會員
              <span>></span>
              帳號註冊
            </div>
          </div>
          <div class="content-contact">
            <div class="content-contact-border">
              <div class="member-box register">
                <h3>恭喜您已完成帳號認證，請至會員專區填寫資料。</h3>
              </div>
            </div>
          </div>
        </template>
        <template v-if="nowStep === 5">
          <div class="content-title">
            <h2>認證</h2>
            <div class="bread">
              <router-link to="/">
                <i class="fas fa-home fa-lg"></i>
              </router-link>
              <span>></span>
              加入會員
              <span>></span>
              帳號註冊
            </div>
          </div>
          <div class="content-contact">
            <div class="content-contact-border">
              <div class="member-box register">
                <h3>驗證錯誤，請重新發送驗證信並驗證。</h3>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <Popup v-if="openPopup">
      <div class="popupPayTypeSuccess">
        <h3>
          恭喜您！已完成此次"帳號註冊"
          <br />
          您的帳號驗證信已經寄至
          <br />
          <br />
          <span class="orange">{{ RegisterData.Email }}</span>
        </h3>
        <p>請至您的電子信箱收取信件，並按照信件指示完成帳號驗證。</p>
        <p>
          如果經過一段時間，您仍然沒有收到報名帳號驗證信，郵件有可能被分類到垃圾信件，請查看您的垃圾信件。
        </p>
        <p>
          ※請設置<span class="orange">oralhealth.taiwan@gmail.com</span
          >郵件為非垃圾郵件，<br />並加入為聯絡人，避免郵件丟失。
        </p>
        <div class="btn blue-btn submission-btn" @click.prevent="closePopup">
          <a class href="javascript:;">完成註冊</a>
        </div>
      </div>
    </Popup>
  </div>
</template>

<script>
import API from '@/assets/api/member';
import Sidentify from '@/components/Identify.vue';
import Popup from '@/components/PopupMember.vue';
import Common from '@/common';
import BG from '../assets/images/index_bg_big.png';

export default {
  name: 'Register',
  components: {
    Sidentify,
    Popup,
  },
  data() {
    return {
      BG,
      Steps: [
        {
          Title: '註冊帳號',
          Title2: '',
          Info: '點擊左側 "加入會員" ，填寫您欲註冊之E-mail帳號及密碼。',
          Remark: '',
        },
        {
          Title: '接收驗證信',
          Title2: '',
          Info: '"Step.01"確認送出後，請接收註冊驗證信。',
          Remark: '※若未接收到，請再次點擊"寄送驗證信"，進行驗證。',
        },
        {
          Title: '填寫會員申請書',
          Title2: '',
          Info: '"Step.02"完成後，請填寫入會申請書。',
          Remark: '',
        },
        // {
        //   Title: '繳費完成，上傳繳費證明',
        //   Title2: '',
        //   Info: '"Step.03"完成註冊與驗證後，請前往繳費並上傳。',
        //   Remark: '※繳費完成後，請將繳費證明上傳。',
        // },
        {
          Title: '繳費完成',
          Title2: '',
          Info: '"Step.03"完成註冊與驗證後，請前往繳費。',
          Remark: '※繳費完成後，請等候審核。',
        },
        {
          Title: '上傳入會資料',
          Title2: '',
          Info: '"Step.04"完成後，上傳所需入會資料(僅學生身分者)。',
          Remark: '※請您留意上傳資料須清楚可檢視即可！',
        },
        {
          Title: '學會審核',
          Title2: '',
          Info: '"Step.05"完成後，約3-5個審核工作天。',
          Remark:
            '※您可隨時留意會員專區，或隨時留意學會通知信，若有問題您可至"會員專區"確認並處理。',
        },
        {
          Title: '審核完成，成為正式會員',
          Title2: '',
          Info: '"Step.06"完成後，請您可至會員專區，確認狀態及變更為"正式會員"。',
          Remark:
            '※會員狀態，會期時間將會顯示您的繳費資訊(含入會費用及當年會費。)',
        },
      ],
      RegisterData: {
        Email: '',
        Password: '',
        CheckPwd: '',
        ValidationUrl: 'https://www.tadhtw.org/register',
      },
      nowStep: 1,
      identifyCode: '',
      identifyCodes: '23456789ABCDEFGHJKMNPQRSTUVWXYZ',
      InputId: '',
      openPopup: false,
      registerId: '',
      registerCode: '',
    };
  },
  methods: {
    goNext(step) {
      const vm = this;
      vm.nowStep = step;
      window.scrollTo(0, 0);
    },
    /* 圖形驗證 */
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    refreshCode() {
      this.identifyCode = '';
      this.makeCode(this.identifyCodes, 4);
      // console.log("當前驗證碼==", this.identifyCode);
    },
    makeCode(o, length) {
      for (let i = 0; i < length; i += 1) {
        this.identifyCode += o[this.randomNum(0, o.length)];
      }
    },
    Reset() {
      const vm = this;
      vm.RegisterData = {
        email: '',
        password: '',
        password2: '',
      };
    },
    // 驗證email
    IsEmail(email) {
      // eslint-disable-next-line no-useless-escape
      const regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      if (!regex.test(email)) {
        return false;
      }
      return true;
    },
    // eslint-disable-next-line consistent-return
    Register() {
      const vm = this;
      if (vm.RegisterData.Email === '') {
        vm.$swal({
          icon: 'warning',
          text: '帳號信箱為空',
          confirmButtonText: '確定',
        });
        return false;
      }
      if (!vm.IsEmail(vm.RegisterData.Email)) {
        vm.$swal({
          icon: 'warning',
          text: '帳號信箱格式錯誤。',
          confirmButtonText: '確定',
        });
        return false;
      }
      if (vm.RegisterData.Password === '') {
        vm.$swal({
          icon: 'warning',
          text: '密碼為空',
          confirmButtonText: '確定',
        });
        return false;
      }
      if (vm.RegisterData.Password !== vm.RegisterData.CheckPwd) {
        vm.$swal({
          icon: 'warning',
          text: '密碼不一致 請再輸入一次!',
          confirmButtonText: '確定',
        });
        vm.$set(vm.RegisterData, 'Password', '');
        vm.RegisterData.CheckPwd = '';
        return false;
      }
      if (vm.InputId === '') {
        vm.$swal({
          icon: 'warning',
          text: '請輸入驗證碼!',
          confirmButtonText: '確定',
        });
        vm.refreshCode();
        return false;
      }
      if (vm.InputId !== vm.identifyCode) {
        vm.$swal({
          icon: 'warning',
          text: '驗證碼輸入錯誤，請重新輸入!',
          confirmButtonText: '確定',
        });
        vm.refreshCode();
        return false;
      }
      // vm.nowStep = 3;
      vm.$store.dispatch('updateLoading', true);
      API.getRegister(vm.RegisterData).then((result) => {
        // console.log(result);
        vm.$store.dispatch('updateLoading', false);

        if (result.status === 200) {
          // 註冊成功 打登入API
          const login = {
            Account: vm.RegisterData.Email,
            Password: vm.RegisterData.Password,
            SpCode: 1,
          };
          API.getLogin(login).then((res) => {
            if (res.status === 200) {
              const token = res.data.Data;
              Common.setCookie('token', token, 0.35);
              vm.nowStep = 3;
            }
            // vm.popupshow = true;
            // setTimeout(() => {
            //   location.href = '/Member/Status';
            // }, 8000);
          });
        } else {
          vm.$swal({
            icon: 'warning',
            text: result.data.Message,
            confirmButtonText: '確定',
          });
        }
      });
    },
    openPop() {
      const vm = this;
      // const ValidationUrl = 'http://localhost:8080/#/register';
      const ValidationUrl = 'https://www.tadhtw.org/register';
      vm.$store.dispatch('updateLoading', true);
      API.SendEmail(
        Common.getCookie('token'),
        JSON.stringify(ValidationUrl),
      ).then((res) => {
        vm.$store.dispatch('updateLoading', false);
        if (res.status === 200) {
          vm.openPopup = true;
        } else {
          vm.$swal({
            icon: 'warning',
            text: '網路錯誤，請稍後再試。',
            confirmButtonText: '確定',
          });
        }
        // console.log(res);
      });
      // vm.openPopup = true;
    },
    closePopup() {
      const vm = this;
      vm.$router.push('/');
    },
  },
  created() {
    const vm = this;
    vm.refreshCode(); // 初始化圖形驗證
    if (Common.GetUrlParams('status') === '200') {
      vm.nowStep = 4;
      // const validateItem = {
      //   Id: Common.GetUrlParams('id'),
      //   Code: Common.GetUrlParams('code'),
      // };
      // API.getValidateMail(validateItem).then((res) => {
      //   // console.log(res);
      // });
    } else if (Common.GetUrlParams('status') && Common.GetUrlParams('status') !== '200') {
      vm.nowStep = 5;
    }
  },
};
</script>

<style lang="scss">
.member-box.register {
  p {
    font-size: 1rem;
    color: #666666;
    font-weight: unset;
    line-height: 2;

    span {
      color: #ee8b59;
      font-size: 1rem;
    }
  }
}
.popupPayTypeSuccess {
  @media (max-width: 360px) {
    padding-top: 100px;
  }
  @media (max-width: 320px) {
    padding-top: 200px;
  }
}
</style>
